










import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class ErrorMessages extends Vue {
  @Prop()
  public messages!: string[]

  get alertEnable(): boolean {
    return this.messages.length > 0
  }

  get displayMessages(): string {
    if (this.alertEnable) {
      const ret = this.messages.reduce(
        (acc, message) => acc + "\n" + message,
        ""
      )
      return ret.trim()
    } else {
      return ""
    }
  }
}
